const sidebarDefaultMap = [
    ['bookmarks', 'sidebar-bookmark'],
    ['pages', 'sidebar-thumbnail-panel'],
    ['thumbnail', 'thumbnail-sidebar-panel'],
    ['comments', 'comment-list-sidebar-panel'],
    ['attachments', 'sidebar-attachment'],
    ['fields', 'sidebar-field'],
    ['signatures', 'sidebar-signature'],
    ['layers', 'sidebar-layers'],
];

export const sidebarDefaultPanelsList = sidebarDefaultMap.map(([key, name]) => name);

export const sidebarMap = [
    ...sidebarDefaultMap,
    ['articles', 'sidebar-article'],
    ['destinations', 'sidebar-destinations']
];

export const sidebarPanelMap = sidebarMap.reduce((obj, [key, name]) => {
    obj[key] = name;
    return obj;
}, {});
